import { Component, OnInit, Input, Output, ChangeDetectionStrategy, OnChanges, SimpleChanges, SimpleChange, OnDestroy } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { RxMethods } from '../../services/rxjs.service';

@Component({
  selector: 'app-multi-select',
  templateUrl: './multi-select.component.html',
  styleUrls: ['./multi-select.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultiSelectComponent implements OnInit, OnChanges, OnDestroy {

  constructor(private rxMethods: RxMethods) { }
  selectedItems: SelectItem[];
  @Input() list: any[];
  @Input() configs: object;
  @Input() formGroup?: FormGroup;
  @Output() change?: any = new EventEmitter();
  onItemChanged = this.rxMethods.createSubjectService();
  onValueChanged = this.rxMethods.createSubjectService();
  selectedItem: any;

  onChange(event: any) {
    if (this.formGroup && this.formGroup.value) {
      this.formGroup.controls[this.configs['id']].patchValue(event.value);
      const values = {
        formData: event.value,
        isSelectedAll: !(!!event.itemValue)
      }
      this.change.emit(values);
    } else {
      this.selectedItem = event.value;
      // this.onItemChanged.next(event);
      this.onValueChanged.next(event.value);
    }
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    const currentItem: SimpleChange = changes.list ? changes.list : changes.chartData;
    if (currentItem && currentItem.currentValue) {
      this.list = [...currentItem.currentValue];
    }
  }

  ngOnDestroy(): void {
    this.onItemChanged.unsubscribe();
    this.onValueChanged.unsubscribe();
  }
}
